import { ReactElement } from "react";

import { ICatalogueCustomization } from "../../../apis/useGetCatalogueData/types";
import { centsToDollarsDisplay } from "../../../common/helpers/stringUtils";
import Condition from "../../../components/Conditional/Condition";
import I18nText from "../../../components/I18nText/I18nText";

interface IProps {
	customizations: ICatalogueCustomization[];
}

const PaymentDetailCustomizations = ({ customizations }: IProps): ReactElement => {
	return (
		<ul className="CartItemiCustomizations">
			{customizations.map((customization) => (
				<li className="Customization" key={customization.id}>
					<span className="CustomizationTitle">
						<I18nText
							enText={customization.title_en || customization.title}
							cnText={customization.title_cn}
						/>
						:
					</span>
					<ul className="Options">
						{customization.food_supplier_customization_option?.map((option) => (
							<li key={option.id} className="Option">
								<I18nText
									className="OptionTitle"
									enText={option.title_en || option.title}
									cnText={option.title_cn}
								/>
								<Condition check={option.price_diff > 0}>
									<span className="OptionPrice TabularNums">{`+ $${centsToDollarsDisplay(option.price_diff)}`}</span>
								</Condition>
							</li>
						))}
					</ul>
				</li>
			))}
		</ul>
	);
};

export default PaymentDetailCustomizations;
